<template>
    <v-container fluid>
        <v-row dense>
            <v-col cols="12" md="11">
                <v-autocomplete
                v-model="selected"
                :loading="loading"
                :items="items"
                item-text="value"
                :filter="filterObject"
                :search-input.sync="search"
                flat
                dense
                multiple
                chips
                clear-icon
                clearable
                hide-no-data
                hide-details
                label="Select a category"
                :menu-props="{ auto: true}"
                solo
                return-object
                >
                    <template v-slot:item="data">
                        <template v-if="typeof data.item !== 'object'">
                            <v-list-item-content v-text="data.item"></v-list-item-content>
                        </template>
                        <template v-else>
                            <div v-if="data.item.level==='3'" class="pl-4"></div>
                            <v-list-item-avatar v-if="data.item.icon!==false">
                            <v-icon>{{data.item.icon}}</v-icon>
                            </v-list-item-avatar>
                            <v-list-item-content>
                            <v-list-item-title v-html="data.item.value"></v-list-item-title>
                            <v-list-item-subtitle v-if="data.item.parent" v-html="data.item.parent"></v-list-item-subtitle>
                            </v-list-item-content>
                        </template>
                    </template>
                </v-autocomplete>
            </v-col>
            <v-col cols="12" md="1">
                <v-btn :disabled="selected.length === 0" icon color="primary" @click="clearCategories()">
                    <v-icon>mdi-close</v-icon>
                </v-btn>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
import Categories from './../config/categories.js'

export default {
    data () {
      return {
        loading: false,
        items: [],
        search: "",
        selected: [],
        categoriesList: Categories
      }
    },
    props: {
        parentSelectMode: Boolean
    },
    watch: {
        search (val) {
            this.searchCategories(val);
        },
        selected (newVal) {   
            if (this.parentSelectMode){         
                if (newVal.length > 0){
                    //Compare the old to the new so that we get our single new addition to the selected list
                    const newCategory = newVal[newVal.length - 1];
                    //*Only do this for the AddTreatmentPopup??? This can be covered in a future call?
                    
                        //If this item added is a 'child'
                        if (newCategory.level && newCategory.level > 1) {
                            var filteredItem = [];
                            //Add the parent as well, by searching in our list for that parent, then calling the usual method of pushing
                            const parentItem = this.categoriesList.filter(category => {
                                //If on level 3, we have to loop through each of the children whilst trying to filter
                                if (newCategory.level > 2 && category.children){
                                    category.children.forEach(childCategory => {
                                        if (childCategory.value){
                                            if (newCategory.parent === childCategory.value){
                                                filteredItem = [{ value: childCategory.value, parent: category.value, level: "2", icon: "mdi-chevron-right"}];
                                            }
                                        }
                                        else {
                                            if (newCategory.parent === childCategory){
                                                filteredItem = [{ value: childCategory.value, parent: category.value, level: "2", icon: "mdi-chevron-right"}];
                                            } 
                                        }
                                    });
                                    //After we have a filtered item, we can return this to the first level of filter
                                    if (filteredItem.length > 0){
                                        return filteredItem[0];
                                    }
                                }
                                return newCategory.parent === category.value;
                            });
                            //If there is a filteredItem, it means it has been filtered from level '3'. We should prioritise adding this first
                            if (filteredItem.length > 0){
                                if (!this.alreadySelected(filteredItem[0]))
                                {
                                    this.selected.push(filteredItem[0]);
                                }                                
                            } else {
                                if (!this.alreadySelected(parentItem[0]))
                                {
                                    this.selected.push(parentItem[0]);
                                }
                            }
                        }
                    }
                }

            var outputVal = [];
            newVal.forEach(function (v){
                outputVal.push(v.value);
            })
            //Emit the selected values when a change is made here
            this.$emit("valueChanged", outputVal);
        }
    },
    computed: {
    },
    methods: {
        querySelections (searchTerm) {
            var queriedList = [];
            this.loading = true

            /////////COULD WE CREATE A 'CHECK FOR MATCH' FUNCTION THAT TAKES IN THE ITEMS?????/////////

            //Loop through every item in the categoriesList array
            for (var i = 0; i < this.categoriesList.length; i++) {
                var parentCategory = this.categoriesList[i];
                //If the item is an object --> Loop the children
                if (typeof parentCategory === 'object'){
                    var foundInChild = false;
                    var parentPosition = queriedList.length;

                    parentCategory.children.forEach(function(childCategory){
                        //If the item is an object
                        if (typeof childCategory === 'object'){
                            //Check if there is a match in the 'value' or if the searchTerm is empty we'll just return everything
                                if (childCategory.value.toLowerCase().includes(searchTerm.toLowerCase()) || searchTerm.trim() === ""){
                                    //If there is a match, push it to the list with a 'level 2' icon
                                    queriedList.push({ value: childCategory.value, parent: parentCategory.value, level: "2", icon: "mdi-chevron-right"});

                                    //Loop through its children and just always add them at this layer
                                    childCategory.children.forEach(function (level2Child){
                                        //For each one just always add them, using the same 'if Object' principle
                                        if (typeof level2Child === 'object'){
                                            //Push them to a list with a 'Level 3' Icon
                                            queriedList.push({ value: level2Child.value, parent: childCategory.value, level: "3", icon: "mdi-chevron-double-right"})
                                        } else {
                                            queriedList.push({ value: level2Child, parent: childCategory.value, level: "3", icon: "mdi-chevron-double-right"})
                                        }
                                    });
                                    //If it does match, then we can mark to add to our array at current position
                                    foundInChild = true;
                                }
                        } else {
                            //Just check if there is a match
                            if (childCategory.toLowerCase().includes(searchTerm.toLowerCase()) || searchTerm.trim() === ""){
                                //If there is a match, push it to the list with a 'level 2' icon
                                queriedList.push({ value: childCategory, parent: parentCategory.value, level: "2", icon: "mdi-chevron-right"});

                                //If it does match, then we can mark to add to our array at current position
                                foundInChild = true;
                            }
                        }
                    });

                    //If one of the parent's children matched, add it regardless
                    if (foundInChild){
                        queriedList.splice(parentPosition, 0, {divider: true}); //Add a Divider to the top
                        queriedList.splice(parentPosition+1, 0, {value: parentCategory.value, level: "1", icon: false}); //Add the category itself
                        queriedList.splice(parentPosition+2, 0, {header: 'Sub-categories'}); //Add a label for the sub-categories that were found
                    } else {
                        //Otherwise, If it has still not been added check if the term matches the parent
                        if (parentCategory.value.toLowerCase().includes(searchTerm.toLowerCase())){
                            //add that string in
                            queriedList.splice(parentPosition, 0, {divider: true}); //Add a Divider to the top
                            queriedList.splice(parentPosition+1, 0, {value: parentCategory.value, level: "1", icon: false}); //Add the category itself
                        }
                    }
                    
                //After it has looped its children, if a child has 'matched' ---> then push this to the list as well

                } else {
                    //If its not an object and just a normal string, check if it matches
                    if (parentCategory.value.toLowerCase().includes(searchTerm.toLowerCase())){
                        //add that string in
                        queriedList.push({ value: parentCategory.value, level: "1", icon: false});
                    }
                }
            }

            this.loading = false;
            return queriedList;
        },
        filterObject(item){
            return item;
        },
        searchCategories(searchTerm){
            //The search term should be allowed to pass if it was blank
            if (searchTerm !== null && searchTerm !== undefined) {
                this.items = this.querySelections(searchTerm);
            }
        },
        clearCategories(){
            //Simply reset the v-models that the category control is attatched to
            this.selected = [];
            this.search = "";
        },
        //Comparer for filtering out the differences between selected watcher updates
        diffComparer(otherArray){
            return function(current){
                return otherArray.filter(function(other){
                return other.value == current.value && other.parent == current.parent
                }).length == 0;
            }
        },
        alreadySelected(item){
            return this.selected.some(selectedItem => {
                if ((selectedItem.value === item.value) && (selectedItem.parent === item.parent)){
                    return true;
                }
            });
        }
    },
}
</script>